export const documentProvider = (): Document => document
